import type { SVGProps } from 'react';

export const SvgIconNavShopping = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={49} height={48} viewBox="0 0 49 48" fill="none" {...props}>
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21.244 32.028 44.742 18.46l-16.97-9.8L4.272 22.23z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.505 27.558 37.003 13.99l-1.493-.862L12.01 26.696z"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m21.245 44.839 23.498-13.566V18.46L21.245 32.026z"
    />
    <path
      fill="#C79B69"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m4.271 35.042 16.972 9.798V32.027l-16.97-9.798z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.505 30.75v-3.192l-1.493-.862v3.192zM13.505 40.37v-3.192l-1.494-.862v3.192z"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m22.28 18.495 16.17-9.337L27.092 2.6l-16.17 9.337z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m17.347 15.646 16.17-9.337-1.494-.862-16.17 9.337z"
    />
    <path
      fill="#DEBD8D"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m22.28 27.199 16.17-9.337V9.156l-16.17 9.337z"
    />
    <path
      fill="#C79B69"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.92 20.642 22.28 27.2v-8.706l-11.359-6.557z"
    />
    <path
      fill="#FF0019"
      stroke="#FF0019"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.347 18.562v-2.916l-1.494-.863V17.7zM17.347 24.353v-2.916l-1.494-.862v2.915z"
    />
    <path
      stroke="#FF0019"
      strokeWidth={1.5}
      d="M9.834 2.5h4M11.834.5v4M.083 15.5h4M2.084 13.5v4M44.084 8.5h4M46.084 6.5v4"
    />
  </svg>
);
